import type { NextPage } from 'next';
import Image from 'next/image';
import styles from './property1-desktop.module.scss';
import FooterButton from './components/FooterButton/FooterButton';
import SubFooter from './components/SubFooter/SubFooter';
import { Property1DesktopType } from '@/types/footer.types';

const Footer: NextPage<Property1DesktopType> = ({
  className = '',
  property1 = 'Desktop',
}) => {
  return (
    <footer
      className={[styles.property1desktop, className].join(' ')}
      data-property1={property1}
    >
      <section className={`${styles.headerTop}`}>
        <div className="container">
          <div className={styles.section1}>
            <div className={styles.contacts1}>
              <div className={styles.phoneblock}>
                <div className={styles.phone}>Phone</div>
                <div className={styles.flyHeraParent}>
                  <a href="tel:18335394372" className={styles.phoneLink}>
                    <div className={styles.flyHera}>1-833-FLY-HERA</div>
                  </a>
                </div>
              </div>
              <div className={styles.mail1block}>
                <div className={styles.charterQuotes}>Charter Quotes</div>
                <a
                  href="mailto:charter@heraflight.com"
                  className={styles.phoneLink}
                >
                  <div className={styles.charterheraflightcom}>
                    charter@heraflight.com
                  </div>
                </a>
              </div>
              <div className={styles.mail2block}>
                <div className={styles.inquiriesSales}>Inquiries & Sales</div>
                <a
                  href="mailto:sales@heraflight.com"
                  className={styles.phoneLink}
                >
                  <div className={styles.vipheraflightcom}>
                    sales@heraflight.com
                  </div>
                </a>
              </div>
            </div>
            <div className={styles.rightcol}>
              <div className={styles.socials}>
                <a
                  href="https://instagram.com/heraflight"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.socialLink}
                >
                  <Image
                    width={24}
                    height={24}
                    sizes="100vw"
                    alt="Instagram"
                    src="/img/footer/insta.svg"
                  />
                </a>
                <a
                  href="https://www.facebook.com/heraflightjets/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.socialLink}
                >
                  <Image
                    width={24}
                    height={24}
                    sizes="100vw"
                    alt="Facebook"
                    src="/img/footer/fb.svg"
                  />
                </a>
                <a
                  href="https://www.linkedin.com/company/hera-flight/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.socialLink}
                >
                  <Image
                    width={24}
                    height={24}
                    sizes="100vw"
                    alt="LinkedIn"
                    src="/img/footer/linkedin.svg"
                  />
                </a>
                <a
                  href="https://twitter.com/heraflight"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.socialLink}
                >
                  <Image
                    width={24}
                    height={24}
                    sizes="100vw"
                    alt="X (Twitter)"
                    src="/img/footer/x1.svg"
                  />
                </a>
              </div>
              <FooterButton
                color="accent"
                highContrast={false}
                loading={false}
                size={3}
                state="default ✦"
                variant="solid ✦"
                text="Request a call"
                iconStart={false}
                iconEnd={false}
                focusRing={false}
                href="/contact"
              />
            </div>
          </div>
        </div>
      </section>
      <SubFooter />
    </footer>
  );
};

export default Footer;
